// PrivacyPolicy.jsx
import React from "react";
import {
  Box,
  Container,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Link,
} from "@mui/material";

const APP_NAME = "Cardex Medico";
const DEVELOPER_NAME = "FAMBI";

export default function Privacy({
  contactEmail = "soporte@fambi.com", // Cambia este correo
  businessAddress = "Dirección de la empresa (opcional)",
  policyUrl,
  lastUpdated,
}) {
  const defaultUpdated = new Date().toLocaleDateString("es-MX", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  const LAST_UPDATED = lastUpdated || defaultUpdated;

  return (
    <Box sx={{ bgcolor: "background.default", py: { xs: 4, md: 6 } }}>
      <Container maxWidth="md">
        <Typography variant="h3" gutterBottom>
          Política de Privacidad
        </Typography>

        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          Última actualización: {LAST_UPDATED}
        </Typography>

        <Typography paragraph>
          En <strong>{APP_NAME}</strong>, operado por <strong>{DEVELOPER_NAME}</strong>, respetamos tu privacidad y estamos comprometidos con la protección de tus datos personales. Esta Política explica qué información recopilamos, cómo la utilizamos, con quién la compartimos y qué opciones tienes.
        </Typography>

        <Divider sx={{ my: 3 }} />

        {/* SECTION */}
        <Section title="1. Información que recopilamos">
          <Typography paragraph>
            Podemos recopilar los siguientes tipos de información:
          </Typography>
          <List dense>
            <ListItem><ListItemText primary="Datos personales (nombre, correo, teléfono)." /></ListItem>
            <ListItem><ListItemText primary="Datos de uso y estadísticas de la app." /></ListItem>
            <ListItem><ListItemText primary="Archivos cargados, como imágenes." /></ListItem>
          </List>
        </Section>

        <Section title="2. Uso de la Cámara">
          <Typography paragraph>
            La app solicita el permiso <code>android.permission.CAMERA</code> para escanear documentos, QR u otras funciones que requieren cámara. Las imágenes no se usan sin tu consentimiento.
          </Typography>
        </Section>

        <Section title="3. Firebase">
          <Typography paragraph>
            {APP_NAME} utiliza servicios de Firebase (Google) como Firestore, Authentication y Crashlytics para almacenamiento, autenticación y diagnóstico.
          </Typography>
          <Typography variant="body2">
            Más información:{" "}
            <Link href="https://firebase.google.com/support/privacy" target="_blank">
              https://firebase.google.com/support/privacy
            </Link>
          </Typography>
        </Section>

        <Section title="4. Derechos del Usuario">
          <Typography paragraph>
            Puedes solicitar acceso, corrección o eliminación de datos escribiendo a: <strong>{contactEmail}</strong>
          </Typography>
        </Section>

        <Section title="5. Contacto">
          <Typography paragraph>
            Si tienes dudas, contáctanos en: {contactEmail}
            <br />
            {businessAddress && <>Dirección: {businessAddress}</>}
          </Typography>
        </Section>

        {policyUrl && (
          <Typography variant="body2">
            URL de esta política: <Link href={policyUrl}>{policyUrl}</Link>
          </Typography>
        )}

        <Divider sx={{ my: 4 }} />

        <Typography variant="caption">
          Esta política es un modelo informativo y debe personalizarse según las leyes aplicables.
        </Typography>
      </Container>
    </Box>
  );
}

function Section({ title, children }) {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>
      {children}
    </Box>
  );
}
